var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProspect = function SvgProspect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5A6A",
    d: "M19 12c0-1.7-1.3-3-3-3s-3 1.3-3 3 1.3 3 3 3 3-1.3 3-3m-4 0c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1-1-.4-1-1M13 19c0-.6.4-1 1-1h4c.6 0 1 .4 1 1v3h2v-3c0-1.7-1.3-3-3-3h-4c-1.7 0-3 1.3-3 3v3h2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5A6A",
    d: "M7 0v3H5V2H3v1H2C.9 3 0 3.9 0 5v12c0 1.1.9 2 2 2h8v-2H2V5h18v10h2V5c0-1.1-.9-2-2-2h-1V2h-2v1h-2V0zm2 2h4v1H9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5A6A",
    d: "M5 10H3v5h2zM8 12H6v3h2zM11 7H9v8h2z"
  })));
};
export default SvgProspect;